import { Skeleton } from '@mui/material';
import { TimelineContent } from 'app/agriculture/AgTimeline/TimelineContent';

export function TimelineSkeleton() {
    return (
        <>
            {Array.from({ length: 5 }).map((_, i) => (
                <TimelineContent.Row className="TimelineEmptyState">
                    <TimelineContent.Main>
                        <Skeleton
                            variant="rounded"
                            animation="wave"
                            height={32}
                            sx={{
                                backgroundColor: 'rgba(255, 255, 255, 0.04)',
                                borderRadius: '20px',
                                margin: '10px 0',
                                '&::after': {
                                    animationDelay: `${1 + i * 0.2}s`,
                                    background:
                                        'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.04), transparent);',
                                },
                            }}
                        />
                    </TimelineContent.Main>
                </TimelineContent.Row>
            ))}
        </>
    );
}
